import { Buffer } from "buffer";

/**
 * Routines for validating the structure of a JSON object to be used as settings.
 */
function isValidMethod(method: string): boolean {
    return method === "GET" 
        || method === "POST" 
        || method === "PUT" 
        || method === "PATCH";
}

function isValidSource(source: string): boolean {
    return source === "Token" 
        || source === "Raw";
}

function isAlphaNumeric(str: string): boolean {
    if(typeof str !== "string") return false;
    return /^[a-zA-Z0-9]+$/.test(str) &&  str.trim().length > 0;
}

function isAlphaNumericWithUnderScores(str: string): boolean {
    if(typeof str !== "string") return false;
    return /^[a-zA-Z0-9_]+$/.test(str) && str.trim().length > 0;
}

function isAlphaNumericWithHyphens(str: string): boolean {
    if(typeof str !== "string") return false;
    return /^[a-zA-Z0-9-]+$/.test(str) && str.trim().length > 0;
}

function isValidURL(str: string): boolean {
    try {
        new URL(str);
        return true;
    } catch (_) {
        return false;
    }
}

function isValidURLEncoded(str: string): boolean {
    //base64 decode string
    try {
        const decoded = Buffer.from(str, "base64").toString("ascii");
        //check if it is a valid URL
        console.log(decoded);
        return isValidURL(decoded);
    } catch (_) {
        console.log(_)
        return false;
    }
}

export function validProxySettings(name: string, settingsObject: any) {
    if (!isAlphaNumeric(name)) {
        console.log("Invalid name: " + name);
        return false;
    }
    if (!isValidMethod(settingsObject.method)) {
        console.log("Invalid method: " + settingsObject.method);
        return false;
    }
    if (!isAlphaNumericWithUnderScores(settingsObject.b2cPolicy)) {
        console.log("Invalid b2cPolicy: " + settingsObject.b2cPolicy);
        return false;
    }
    if (!isValidURLEncoded(settingsObject.endpoint)) {
        console.log("Invalid endpoint: " + settingsObject.endpoint);
        return false;
    }
    if (!settingsObject.headers){
        console.log("Invalid headers: " + settingsObject.headers);
        return false;
    }
    for (const header of settingsObject.headers) {
        if (!isAlphaNumericWithHyphens(header.destinationHeader)) {
            console.log("Invalid destinationHeader: " + header.destinationHeader);
            return false;
        }
        if(!isAlphaNumericWithUnderScores(header.value)) {
            console.log("Invalid value: " + header.value);
            return false;
        }
        if (!isValidSource(header.source)) {
            console.log("Invalid source: " + header.source);
            return false;
        }
    }
    return true;
}

export {
    isValidMethod,
    isValidSource,
    isAlphaNumeric,
    isAlphaNumericWithHyphens,
    isValidURL,
    isValidURLEncoded,
    isAlphaNumericWithUnderScores
}